module.exports = __webpack_public_path__ + "static/img/03.4c7cb6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/03.jpg
// module id = WxXp
// module chunks = 0